// Auto-generated normalizer for table: DireccionesUnidadesOrg
export function direccionesUnidadesOrgNormalize(row) {
    return {
        idDireccion: row.idDireccion ?? row.IdDireccion ?? row['IdDireccion'] ?? 0,
        tipoDireccion: row.tipoDireccion ?? row.TipoDireccion ?? row['TipoDireccion'] ?? '',
        calle: row.calle ?? row.Calle ?? row['Calle'] ?? '',
        numeroExterior: row.numeroExterior ?? row.NumeroExterior ?? row['NumeroExterior'] ?? '',
        numeroInterior: row.numeroInterior ?? row.NumeroInterior ?? row['NumeroInterior'] ?? '',
        colonia: row.colonia ?? row.Colonia ?? row['Colonia'] ?? '',
        municipio: row.municipio ?? row.Municipio ?? row['Municipio'] ?? '',
        estado: row.estado ?? row.Estado ?? row['Estado'] ?? '',
        codigoPostal: row.codigoPostal ?? row.CodigoPostal ?? row['CodigoPostal'] ?? '',
        pais: row.pais ?? row.Pais ?? row['Pais'] ?? '',
        esPrincipal: row.esPrincipal ?? row.EsPrincipal ?? row['EsPrincipal'] ?? false,
        activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    };
}
